export default "__VITE_ASSET__DLKRhiMA__"